<ng-progress [spinner]="false" [meteor]="false"></ng-progress>
<app-nav-bar
  (changeKey)="openChangeKeyModal()"
  (navigate)="showApiKeyModal = false"
  [authenticated]="authService.isAuthenticated()">
</app-nav-bar>

<div [class.blurred]="showApiKeyModal">
  <main class="container pb-5">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- API Key Modal -->
<div class="key-overlay" *ngIf="showApiKeyModal" (click)="showApiKeyModal = false">
  <div class="key-modal" (click)="$event.stopPropagation()">
    <h4>API Key</h4>
    <p class="key-hint">Enter your API key to unlock subscriptions and settings</p>
    <form (ngSubmit)="validateAndSaveKey()" autocomplete="on">
      <input type="hidden" name="username" autocomplete="username" value="api-key">
      <div class="input-group">
        <input
          [type]="showKey ? 'text' : 'password'"
          class="form-control form-control-lg"
          [class.dimmed-border]="!apiKeyInput.trim().length"
          placeholder="Enter your API key"
          [(ngModel)]="apiKeyInput"
          name="password"
          autocomplete="current-password">
        <button
          class="btn btn-lg btn-primary px-md-4 pt-2"
          type="submit"
          [disabled]="!apiKeyInput.trim().length || validating">
          <span *ngIf="!validating">
            <svg class="me-sm-2" fill="currentColor" width="20" height="20" style="position: relative; top: -2px;">
              <use href="/assets/icons.svg#icon-right"></use>
            </svg>
          </span>
          <span *ngIf="validating" class="spinner-border spinner-border-sm"></span>
        </button>
      </div>
    </form>
    <div class="key-actions">
      <label class="show-key">
        <input type="checkbox" [(ngModel)]="showKey"> Show key
      </label>
      <button
        class="clear-key"
        *ngIf="authService.isAuthenticated()"
        (click)="clearApiKey()">
        Clear current key
      </button>
    </div>
    <p class="key-error" *ngIf="keyError">{{ keyError }}</p>
  </div>
</div>
